import {
  TransactionStatus,
  TransactionType,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';
import { TransactionHelpers } from '../../transaction-helpers';

function isMohTransactionExtendedData(_data: unknown): _data is unknown {
  return true;
}

export class VoidMohTransaction implements ITransactionAction<unknown> {
  icon = 'block';
  label = 'Void';
  tooltip = 'Void if claim has been manually cancelled via MOH';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isMohTransactionExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(data: ITransactionActionsData<unknown>): Observable<boolean> {
    return TransactionHelpers.lastTransaction$(
      data,
      isMohTransactionExtendedData
    ).pipe(
      map((transaction) => {
        if (!transaction) {
          return false;
        }
        return (
          transaction.type === TransactionType.Incoming &&
          transaction.status !== TransactionStatus.Failed
        );
      })
    );
  }

  async do(data: ITransactionActionsData<unknown>): Promise<void> {
    this.inProgress$.next(true);
    await this._actions.cancel(
      data.invoice,
      data.latestTransaction,
      'Void MOH Claim'
    );
    this.inProgress$.next(false);
  }
}
